import {useOutletContext} from "react-router-dom";
import {useEntityPermissions} from "snimf/permissions/hooks";
import {EntityViewSubPage} from "base/entity/components/container";
import {ViewOrUpdateViolationHolderContent} from ".";

const ViewViolationHolderSubPage = () => {
    const context = useOutletContext();
    const violation = context[0];

    const {allowEdit} = useEntityPermissions(violation, "violations");

    let sections = [
        <ViewOrUpdateViolationHolderContent
            key="holder"
            violation={violation}
            allowEdit={allowEdit}
        />,
    ];

    return violation && <EntityViewSubPage sections={sections} />;
};

export default ViewViolationHolderSubPage;
